import { Injectable } from "@angular/core";
import { AuthService } from "./auth.service";

@Injectable({ providedIn: 'root' })
export class RoleService {

    constructor(private authService: AuthService) { }

    // [AUTH-25] All three checks share AuthService.roles(), which normalizes the string-or-array
    // `role` claim and never throws — a single-role admin token now passes isAdmin, and a
    // malformed token simply has no roles.
    isAdmin(): boolean {
        return this.authService.roles().includes('admin');
    }

    isUser(): boolean {
        const roles = this.authService.roles();
        return roles.includes('user') || roles.includes('admin');
    }

    isTestee(): boolean {
        return this.authService.isTestee();
    }
}
